// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"fW-z","inlineTitle":"gW-z","sponsoredAdsWrapper":"hW-z","marketplaceRecosWrapper":"iW-z"};